const walletFormatter = (value) => {
  return `${value.slice(0, 6)}...${value.substr(-6)}`
};

export default walletFormatter;